import { useEffect, useState } from "react";
import Table from "../../components/common/Table/Table";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { transactionTableColumns } from "../../config/tableColumns";
import api from "../../api/ApiService";
import { getStoredItem } from "../../config/storageUtils";
import { incentiveClaimTypesList } from "../../config/applicationStatusConfig";
import { installmentsList } from "../../config/appliedSchemesConfig";
import { formatDateTime } from "../../utils/utils";
import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";

const ApplicationTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [rawTransactions, setRawTransactions] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const { language, setLanguage } = useLanguage();

  useEffect(() => {
    const getUserDetails = async () => {
      const resp = await api.get("/user-full-data");
      if (resp.status === 200) {
        setUserDetails(resp.data);
      }
    };
    getUserDetails();
  }, []);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await api.get(
          `user-transactions/${userDetails?.user_details?.id}`,
        );
        setRawTransactions(response.data || []);
      } catch (error) {
        console.error("Failed to fetch data", error);
      }
    };

    fetchTransactions();
  }, [userDetails?.user_details?.id]);

  useEffect(() => {
    const formatted = rawTransactions.map((item, index) => {
      const subsidyLabel = language
        ? incentiveClaimTypesList.find((i) => i.value === item?.subsidy)?.hi
        : incentiveClaimTypesList.find((i) => i.value === item?.subsidy)
            ?.label || "N/A";

      const installmentName = language
        ? installmentsList.find((i) => i.value === item?.installment)?.hi
        : installmentsList.find((i) => i.value === item?.installment)?.name ||
          "N/A";

      const rawStatus = item?.status?.toLowerCase();
      const status = language
        ? rawStatus === "paid"
          ? "भुगतान किया गया"
          : "असफल"
        : item?.status || "N/A";

      const rawMode = item?.payment_mode?.toLowerCase();
      const paymentMode = language
        ? rawMode === "online"
          ? "ऑनलाइन"
          : rawMode === "offline"
            ? "ऑफलाइन"
            : "N/A"
        : item?.payment_mode || "N/A";

      return {
        sr_no: index + 1,
        caf_id: userDetails?.caf_id,
        unit_name: item?.fullname || "N/A",
        payment_mode: paymentMode,
        status: status,
        amount: item?.amount || "N/A",
        total_eligible_investment_after_non_eligible_deduction:
          item?.total_eligible_investment_after_non_eligible_deduction || "N/A",
        total_max_capital_subsidy: item?.total_max_capital_subsidy || "N/A",
        subsidy: subsidyLabel,
        installment: installmentName,
        created_at: formatDateTime(item?.created_at),
      };
    });

    setTransactions(formatted);
  }, [language, rawTransactions]); // ✅ NO API call

  return (
    <DashboardLayout pageTitle="Transaction List" mainClass="p-6">
      <div className="flex h-12 nav-bg p-3 text-white font-semibold rounded-tr rounded-tl">
        {language ? "लेन-देन सूची" : "Transaction List"}
      </div>
      <>
        <Table
          columns={transactionTableColumns}
          data={transactions}
          language={language}
        />
      </>
    </DashboardLayout>
  );
};

export default ApplicationTransactions;
